import React from 'react';
import { IGasType } from './EquipmentDetail';

interface GasTypeBadgeProps {
    gasType: IGasType;
}

const GasTypeBadge: React.FC<GasTypeBadgeProps> = ({ gasType }) => {
    if (!gasType || !gasType.segments || gasType.segments.length === 0) {
        return null;
    }

    const isSingleSegment = gasType.segments.length === 1;
    const isDualSegment = gasType.segments.length === 2;

    if (isSingleSegment) {
        const segment = gasType.segments[0];
        return (
            <span
                className="gas-type-badge gas-type-badge--single"
                style={{
                    backgroundColor: segment.backgroundColor,
                    color: segment.textColor
                }}
            >
                {segment.text}
            </span>
        );
    }

    if (isDualSegment) {
        const leftSegment = gasType.segments[0];
        const rightSegment = gasType.segments[1];

        return (
            <span className="gas-type-badge gas-type-badge--dual">
                <span
                    className="gas-type-badge__segment gas-type-badge__segment--left"
                    style={{
                        backgroundColor: leftSegment.backgroundColor,
                        color: leftSegment.textColor
                    }}
                >
                    {leftSegment.text}
                </span>
                <span
                    className="gas-type-badge__segment gas-type-badge__segment--right"
                    style={{
                        backgroundColor: rightSegment.backgroundColor,
                        color: rightSegment.textColor
                    }}
                >
                    {rightSegment.text}
                </span>
            </span>
        );
    }

    return null;
};

export default GasTypeBadge;
